<div>
  <table class="customTable">
    @for (item of data.details; track item) {
      <tr>
        <td>{{ item.description }}</td>
        <td style="text-align: right">
          @if (item.kind == 'subtotal' || item.kind == 'total') {
            <span>Total: </span>
            }{{ getPrice(item.price) }}
            @if (item.kind == 'subtotal') {
              <div>&nbsp;</div>
            }
          </td>
        </tr>
      }
      <tr>
        <td></td>
        <td style="text-align: right"><a target="_blank" href="https://apple.com">View order summary</a></td>
      </tr>
    </table>
  </div>
